"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// write code here
var list = document.querySelector("ul");
function sortList(listElement) {
    var _listElement;
    var arrayList = Array.from(listElement.children);
    arrayList.sort(function(a, b) {
        return getSalary(b) - getSalary(a);
    });
    (_listElement = listElement).append.apply(_listElement, _to_consumable_array(arrayList));
}
function getSalary(li) {
    var value = li.dataset.salary.replaceAll("$", "").replaceAll(",", "");
    return Number(value);
}
function getEmployees(listElement) {
    return Array.from(listElement.children).map(function(li) {
        var object = {
            name: li.textContent.trim(),
            position: li.dataset.position,
            salary: getSalary(li),
            age: Number(li.dataset.age)
        };
        return object;
    });
}
sortList(list);
getEmployees(list);

//# sourceMappingURL=index.f7d61c1a.js.map
